import styled from "styled-components";
import { createGradientOrSolid } from "../../Helper/utils";

export const StyledBundlePriceButton = styled.div.attrs({className: "bundlePriceButton"})`
    height: ${(props: any) => props.height || "40px"};
    width: ${(props: any) => props.width.normal};
    background: ${(props: any) => createGradientOrSolid(props.buttonColor)};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${(props: any) => props.borderRadius};
    font-weight: 700;
    font-size: 16px;
    color: ${(props: any) => props.buttonTextColor};
    position: relative;

    .white_stripe {
        position: absolute;
        top: 2px;
        height: 8px;
        width: 100%;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    }

    @media (max-width: 374px) {
        height: 30px;
        width: ${(props: any) => props.width.normal};
    }
` as any;

export const StyledBundlePrice = styled.div`
    display: flex;
    direction: ${(props: any) => props.direction};
    color: ${(props: any) => props.buttonTextColor};
    span:first-child {
        margin-right: ${(props: any) => props.marginRight};
        margin-left: ${(props: any) => props.marginLeft};
    }
` as any;
